"use strict";

exports.__esModule = true;
exports.CalendarEventNameField = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var validate = function validate(input) {
  if (!input) {
    return "Event name is required.";
  }
};
var CalendarEventNameField = exports.CalendarEventNameField = function CalendarEventNameField(_ref) {
  var prefix = _ref.prefix;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
    name: prefix + ".name",
    validate: validate
  }, function (_ref2) {
    var input = _ref2.input,
      meta = _ref2.meta;
    return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      intent: meta.touched && meta.error ? "danger" : "secondary",
      helperText: meta.touched && meta.error ? meta.error : translate("CalendarEventNameField.helperText", "The name of this event."),
      label: translate("CalendarEventNameField.label", "Name"),
      labelFor: prefix + ".name",
      requiredLabel: "*"
    }, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
      "data-testid": "CalendarEventNameField",
      defaultValue: input.value,
      onBlur: function onBlur(e) {
        input.onChange(e);
        input.onBlur(e);
      }
    }));
  });
};